module.exports = __webpack_public_path__ + "static/media/md-download.051caee1.svg";